import styled from 'styled-components';
import { Link } from '../../../../../../common/components/Link';
import { IconMapMarker } from '../../../../../../common/components/icons/IconMapMarker/IconMapMarker';
import { ThemeColours } from '../../../../../../common/styles/ThemeColours';
import { FONT_STACK, PRESSABLE_LINK } from '../../../../../../common/styles/constants';

export const MonoPin = styled(IconMapMarker)`
  color: ${ThemeColours.mono600};
  flex-shrink: 0;
  height: 11.67px;
  margin-inline-end: 0;
  padding: 0;
  vertical-align: middle;
  width: 9.33px;
`;

export const PinWrapper = styled.div`
  height: 14px;
  margin-inline-end: 2px;
  width: 14px;
`;

export const AddressView = styled.div`
  ${PRESSABLE_LINK};
  align-items: center;
  color: ${ThemeColours.mono800};
  display: flex;
  flex-direction: row;
  font-size: 12px;
  ${FONT_STACK};
  line-height: 14px;
  margin-top: 2px;
  min-width: 0;
  position: relative;
`;

export const Display = styled(Link)`
  color: ${ThemeColours.mono800};
  overflow: hidden;
  text-decoration: none;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
